import React from 'react';
import { Crown } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-barber-dark border-t border-barber-lightGray py-12 px-4" data-id="element-218">
      <div className="max-w-4xl mx-auto text-center" data-id="element-219">
        <Crown className="w-10 h-10 text-barber-gold mx-auto mb-6" strokeWidth={1.5} data-id="element-220" />
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-barber-text uppercase tracking-[0.2em] mb-8" data-id="element-221">
          {t('footer.tagline')}
        </h2>
        <div className="space-y-2 text-barber-muted mb-8" data-id="element-222">
          <p className="font-logo text-2xl tracking-wider text-barber-text" data-id="element-223">
            VillaCon<span className="text-barber-gold" data-id="element-224">BarberShop</span>
          </p>
          <p data-id="element-225">926A East Tremont Ave, Bronx NY</p>
          <p className="text-barber-gold font-bold" data-id="element-226">{t('footer.hours')}</p>
        </div>
        <p className="text-sm text-barber-muted/50" data-id="element-227">
          © {new Date().getFullYear()} VillaConBarberShop. {t('footer.rights')}
        </p>
      </div>
    </footer>;
}